import { render, staticRenderFns } from "./UsersCalendar.vue?vue&type=template&id=bb151052"
import script from "./UsersCalendar.vue?vue&type=script&lang=js"
export * from "./UsersCalendar.vue?vue&type=script&lang=js"
import style0 from "./UsersCalendar.vue?vue&type=style&index=0&id=bb151052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports